import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Tiempo (ms) que los datos se consideran "frescos". Mientras no expire, React Query
      // devuelve el caché sin rehacer la petición al backend (5 minutos).
      staleTime: 1000 * 60 * 5,
      // Tiempo (ms) que los datos permanecen en memoria después de que ningún componente
      // los usa. Si se vuelve a montar el componente antes de este tiempo, se reutiliza
      // el caché sin nueva petición (30 minutos).
      gcTime: 1000 * 60 * 30,
      // Cantidad de reintentos automáticos cuando una petición falla antes de reportar error.
      retry: 3,
      // Controla si se rehacen las peticiones al volver a enfocar la ventana del navegador.
      // Ejemplo: si el usuario cambia a otra pestaña o a otra aplicación y luego regresa,
      // con true se reharían todas las queries activas; con false (actual) no se rehace nada
      // y se sigue mostrando los datos que ya estaban en caché.
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Las mutaciones (POST, PUT, DELETE) no se reintentan automáticamente ante fallos.
      retry: false,
    },
  },
});
